import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { get_profile, get_notification_count } from "../api/ControllApi";
import { useNavigate } from "react-router-dom";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notificationCount, setNotificationCount] = useState(0);
   const navigate = useNavigate();

  const loadUser = async () => {
    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        setUser(null);
        setLoading(false);
        return;
      }

      const res = await get_profile();

      if (res?.status === 1 || res?.data?.status === 1 || res?.data?.is_deleted === 1) {
        localStorage.removeItem("authToken");
        setUser(null);
        navigate("/", { replace: true });
        return;
      }
      setUser(res.data);
    } catch (err) {

      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchNotificationCount = useCallback(async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return;
      const res = await get_notification_count();
      if (res.status) {
        setNotificationCount(res.count || 0);
      }
    } catch (err) {
      console.error("Failed to fetch notification count", err);
    }
  }, []);

  useEffect(() => {
    loadUser();
  }, []);

  useEffect(() => {
    if (user) {
      fetchNotificationCount();
      const interval = setInterval(fetchNotificationCount, 60000); // 1 minute
      return () => clearInterval(interval);
    }
  }, [user, fetchNotificationCount]);

  return (
    <UserContext.Provider value={{ user, setUser, loadUser, loading, notificationCount, setNotificationCount, fetchNotificationCount }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
